import { __assign, __extends, __read, __rest } from "tslib";
import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import EventEmitter from "eventemitter3";
import { Text, View } from "../_core/components";
import { Icon } from "../icon";
import { Loading } from "../loading";
import { TaroEnv } from "../_util/env";
import { useConfig } from "../_util/use-config";
var ToastEmitter = /** @class */ (function (_super) {
    __extends(ToastEmitter, _super);
    function ToastEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ToastEmitter;
}(EventEmitter));
var toastEmitter = new ToastEmitter();
export function Toast(props) {
    var _a;
    var classPrefix = useConfig().classPrefix;
    var _b = __read(useState(props), 2), options = _b[0], setOptions = _b[1];
    var timerRef = useRef(null);
    useEffect(function () {
        var onShow = function (_a) {
            var _b = _a.duration, duration = _b === void 0 ? 3000 : _b, options = __rest(_a, ["duration"]);
            clearTimeout(timerRef.current);
            setOptions(__assign(__assign({}, options), { visible: true }));
            timerRef.current = setTimeout(function () { return setOptions(function (options) { return (__assign(__assign({}, options), { visible: false })); }); }, duration);
        };
        var onHide = function () {
            clearTimeout(timerRef.current);
            setOptions(function (options) { return (__assign(__assign({}, options), { visible: false })); });
        };
        toastEmitter.on("show", onShow);
        toastEmitter.on("hide", onHide);
        return function () {
            clearTimeout(timerRef.current);
            toastEmitter.removeListener("show", onShow);
            toastEmitter.removeListener("hide", onHide);
        };
    }, []);
    var _c = options.type, type = _c === void 0 ? "default" : _c, visible = options.visible, content = options.content, icon = options.icon, className = options.className, style = options.style;
    var iconProps = typeof icon === "string" ? { name: icon } : icon;
    return (React.createElement(View, { className: classNames(classPrefix + "-toast", className, (_a = {
                "is-shown": visible
            },
            _a[classPrefix + "-toast--pure-text"] = type === "default" && !iconProps,
            _a)), style: style },
        React.createElement(View, { className: classPrefix + "-toast__container" },
            iconProps && React.createElement(Icon, __assign({ size: TaroEnv ? 96 : 48 }, iconProps)),
            type === "loading" && (React.createElement(Loading, { color: "#ffffff", size: TaroEnv ? 64 : 32 })),
            content && (React.createElement(Text, { className: classPrefix + "-toast__text" }, content)))));
}
Toast.show = function (options) { return toastEmitter.emit("show", options); };
Toast.loading = function (options) {
    return toastEmitter.emit("show", __assign(__assign({}, options), { type: "loading" }));
};
Toast.hide = function () { return toastEmitter.emit("hide"); };
//# sourceMappingURL=Toast.js.map